import { STORAGE_KEYS } from "../config";
export const setQuickStartPreference = (dismissed) => {
    if (dismissed) {
        localStorage.setItem(STORAGE_KEYS.quickStartPreference, "dismissed");
    }
};
export const getQuickStartPreference = () => {
    var _a;
    return (_a = localStorage.getItem(STORAGE_KEYS.quickStartPreference)) !== null && _a !== void 0 ? _a : "";
};
